<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
  <tui-breadcrumbs [itemsLimit]="10">
    <ng-container *ngFor="let item of breadcrumbs; let last = last">
      <ng-container *ngIf="last">
        <strong *tuiItem tuiFade>
          {{ item }}
        </strong>
      </ng-container>
      <ng-container *ngIf="!last">
        <button *tuiItem tuiLink type="button">
          {{ item }}
        </button>
      </ng-container>
    </ng-container>
  </tui-breadcrumbs>

  <button
    [routerLink]="['/admin/invoice/add-edit']"
    appearance="secondary"
    tuiButton
    type="button"
    style="border: 2px solid #e5e7ea; font-weight: 800"
    [appDisableUnlessPermission]="'INVOICE_CREATE'"
  >
    Generate New Invoice
  </button>
</nav>

<div class="items-center flex justify-between">
  <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">Invoices</p>
</div>

<search
  class="lg:w-[50%] xl:w-[50%] 2xl:w-[40%]"
  tuiSearch
  style="padding-left: 0"
>
  <fieldset class="border-none" tuiTextfieldSize="m" style="padding-left: 0">
    <div class="flex items-center space-x-4">
      <div class="w-[431px]">
        <tui-textfield iconStart="@tui.search">
          <input
            [(ngModel)]="filters.searchText"
            placeholder="Search"
            (keydown)="onEnter($event)"
            placeholder="Search Invoices"
            tuiTextfield
          />
        </tui-textfield>
      </div>
      <!-- dropDown -->
      <div class="w-[180px]">
        <tui-combo-box
          [stringify]="stringify"
          [(ngModel)]="filters.status"
          (ngModelChange)="applyFilters({ status: filters.status })"
        >
          Status
          <input
            tuiTextfieldLegacy
            placeholder="Select status"
            [value]="stringify(filters.status)"
          />
          <tui-data-list-wrapper
            *tuiDataList
            [items]="items"
            [itemContent]="stringify | tuiStringifyContent"
          />
        </tui-combo-box>
      </div>
      <button size="m" tuiButton type="button" (click)="loadInvoices()">
        Search
      </button>
    </div>
  </fieldset>
  <fieldset
    class="flex items-center space-x-4 border-none"
    style="padding-left: 0"
  >
    <p class="text-sm font-semibold text-[#26293C]">
      Showing results for "{{ filters.searchText || "All Invoices" }}"
    </p>
    <button
      appearance="flat"
      iconStart="@tui.rotate-cw"
      size="xs"
      tuiButton
      type="reset"
      (click)="clearSearch()"
    >
      Clear
    </button>
  </fieldset>
</search>

<div *ngIf="isLoading" class="h-[400px]">
  <tui-loader />
</div>

<!-- Bulk-action bar: visible when at least one row is selected -->
<div *ngIf="!isLoading && selectionCount() > 0"
     class="flex items-center justify-between mt-4 p-3 rounded-md bg-[#F9FBFF] border border-[#E5E7EA]">
  <p class="text-sm font-medium text-[#191C30E5] m-0">
    {{ selectionCount() }} selected
  </p>
  <div class="flex items-center space-x-2">
    <button size="xs" appearance="secondary" tuiButton type="button"
            [disabled]="bulkBusy"
            [appDisableUnlessPermission]="'INVOICE_UPDATE'"
            (click)="bulkSetStatus('Sent')">
      Mark as Sent
    </button>
    <button size="xs" appearance="secondary" tuiButton type="button"
            [disabled]="bulkBusy"
            [appDisableUnlessPermission]="'INVOICE_UPDATE'"
            (click)="bulkSetStatus('Draft')">
      Mark as Draft
    </button>
    <button size="xs" appearance="secondary" tuiButton type="button"
            (click)="exportSelectedToCsv()">
      Export CSV
    </button>
  </div>
</div>

<div *ngIf="!isLoading" class="w-full mt-5 overflow-x-scroll">
  <table tuiTable [size]="size" class="w-full min-w-[1000px]">
    <thead>
      <tr>
        <th
          tuiTh
          style="padding: 0; padding-left: 10px; background-color: #f9fbff; width: 40px;"
        >
          <input type="checkbox" title="Select all on this page"
                 [checked]="isAllSelected()"
                 (change)="toggleSelectAll($any($event.target).checked)" />
        </th>
        <th
          tuiTh
          style="padding: 0; padding-left: 10px; background-color: #f9fbff"
        >
          Invoice No
        </th>
        <th
          tuiTh
          style="padding: 0; padding-left: 10px; background-color: #f9fbff"
        >
          Client Reg No
        </th>
        <th
          tuiTh
          style="padding: 0; padding-left: 10px; background-color: #f9fbff"
        >
          Patient Name
        </th>
        <th
          tuiTh
          style="padding: 0; padding-left: 20px; background-color: #f9fbff;width: 50px;"
        >
          Contact No
        </th>
        <th
          tuiTh
          style="padding: 0; padding-right: 100px; background-color: #f9fbff"
          class="flex items-center justify-end"
        >
          Amount
        </th>
        
        <th
          tuiTh
          style="padding: 0; padding-left: 10px; background-color: #f9fbff"
        >
          Status
        </th>
        <th
          tuiTh
          style="padding: 0; padding-left: 10px; background-color: #f9fbff"
        >
          Created Date
        </th>
        <th
          tuiTh
          style="padding: 0; padding-left: 10px; background-color: #f9fbff"
        >
          Actions
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <tr *ngFor="let invoice of invoiceData">
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <input type="checkbox"
                 [title]="'Select invoice ' + (invoice?.refNo || '')"
                 [checked]="isSelected(invoice._id)"
                 (change)="toggleSelected(invoice._id, $any($event.target).checked)" />
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p
              [routerLink]="['/admin/invoice/', invoice._id]"
              class="text-[#526ED3] text-sm cursor-pointer"
            >
              {{ invoice.refNo }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ invoiceClientDisplayRef(invoice.client) }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ invoice.client.name }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px;width: 50px;">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ invoice.client.guardianContactNo }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px;padding-right: 100px;" >
          <div [tuiCell]="size" class="flex items-center justify-end">
            <p class="text-[#191C30E5] text-sm ">
              LKR {{ invoice.amount | number : "1.2-2" }}
            </p>
          </div>
        </td>
        
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p
            class="text-center w-[75px] py-2 rounded-full text-white"
            [ngStyle]="{
              'background-color': getInvoiceStatusBgColor(invoice.status)
            }"
          >
            {{ invoice?.status }}
          </p>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ invoice.createdAt | date : "MMM d, y" }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <span tuiStatus class="flex items-center">
            <p
              [routerLink]="['/admin/invoice/', invoice._id]"
              class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
            >
              View
            </p>
            <button
              [routerLink]="['/admin/invoice/add-edit', invoice._id]"
              [disabled]="invoice.status === 'Sent'"
              [style.color]="
                invoice?.status === 'Sent'
                  ? '#a6afce'
                  : invoice?.status === 'Draft'
                  ? '#526ED3'
                  : invoice?.status
                  ? '#526ED3'
                  : '#526ED3'
              "
              class="appearance-none bg-white border-none pt-[3px] m-0 text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
            >
              Edit
            </button>
            <div>
              <button
                [disabled]="invoice.status === 'Sent'"
                appearance="action"
                iconStart="@tui.ellipsis"
                size="xs"
                tuiIconButton
                type="button"
                [tuiAppearanceState]="openMap[invoice._id] ? 'hover' : null"
                [tuiDropdown]="content"
                [(tuiDropdownOpen)]="openMap[invoice._id]"
                (click)="toggleDropdown(invoice._id)"
              >
                More
              </button>
              <ng-template #content>
                <tui-data-list
                  tuiDataListDropdownManager
                  [size]="openDropdownsize"
                >
                  <button
                    style="color: black"
                    class="dropdown-button"
                    tuiOption
                    type="button"
                    (click)="toggleStatus(invoice?._id)"
                  >
                    {{ invoice.status === "Draft" ? "Send" : "Draft" }}
                  </button>
                </tui-data-list>
              </ng-template>
            </div>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Pagination Controls -->
<div class="flex justify-end items-center mt-5">
  <tui-pagination
    [index]="pageIndex - 1"
    [length]="getPageCount()"
    (indexChange)="onPageChange($event + 1)"
  >
  </tui-pagination>
</div>
